/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Action_Start_GenericInputs */

const en_us2_search_action_start_generic = /** @type {(inputs: Search_Action_Start_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start workout`)
};

const pt_br2_search_action_start_generic = /** @type {(inputs: Search_Action_Start_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar treino`)
};

const es_419_search_action_start_generic = /** @type {(inputs: Search_Action_Start_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar entrenamiento`)
};

const pt_pt2_search_action_start_generic = /** @type {(inputs: Search_Action_Start_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar treino`)
};

const fr_fr2_search_action_start_generic = /** @type {(inputs: Search_Action_Start_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer la séance`)
};

const de_de2_search_action_start_generic = /** @type {(inputs: Search_Action_Start_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training starten`)
};

const it_it2_search_action_start_generic = /** @type {(inputs: Search_Action_Start_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia allenamento`)
};

/**
* | output |
* | --- |
* | "Start workout" |
*
* @param {Search_Action_Start_GenericInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_start_generic = /** @type {((inputs?: Search_Action_Start_GenericInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_Start_GenericInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_start_generic(inputs)
	if (locale === "es-419") return es_419_search_action_start_generic(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_start_generic(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_start_generic(inputs)
	if (locale === "de-DE") return de_de2_search_action_start_generic(inputs)
	if (locale === "it-IT") return it_it2_search_action_start_generic(inputs)
	return en_us2_search_action_start_generic(inputs)
});
export { search_action_start_generic as "search.action_start_generic" }